import React from 'react'
import { Navbar, Container, Nav, Image } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import { logo } from '../../assets'
import './NavbarComponent.css'

export default function NavbarComponent() {
  let gotoContact =() => {
    let element = document.getElementById('contact-section')
    element.scrollIntoView(true)
  }
  return (
    <Navbar className='navbar-component pt-2 pb-2' expand="lg" id='navbar-component'>
      <Container fluid className='navbar-container'>
        <Navbar.Brand href="/">
          <Image src={logo} className='logo' height='auto' width='90px' />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className='justify-content-end' id="basic-navbar-nav">
          <Nav className="m-0 align-items-lg-center align-items-end" style={{ background: 'linear-gradient(180deg, #C37B13 0%, #C88315 100%)', padding: '12px' }}>
            <NavLink to='/' className={`navbar-link px-4`} activeClassName="active" >HOME</NavLink>
            <NavLink to='/products' className={`navbar-link px-4`} activeClassName="active" >PRODUCTS</NavLink>
            <NavLink to='/brands' className={`navbar-link px-4`} activeClassName="active">BRANDS</NavLink>
            <NavLink to='/sustainability' id='process-link' className={`navbar-link px-4`} activeClassName="active">SUSTAINABILITY</NavLink>
            <Nav.Link onClick={gotoContact} id='contact-link' className={`navbar-link px-4`} >CONTACT</Nav.Link>

            {/* <Button className='mx-2 mt-lg-0 mb-lg-0 m-2' style={{ borderColor: '#000', width: '158px', backgroundColor: '#FFF', color: '#1F232B', fontWeight: '700',fontSize:'1em' }}
                        onClick={gotoContact}>Contact us</Button> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
